import { render, staticRenderFns } from "./Tenderdetail.vue?vue&type=template&id=bdc7357c"
import script from "./Tenderdetail.vue?vue&type=script&lang=js"
export * from "./Tenderdetail.vue?vue&type=script&lang=js"
import style0 from "./Tenderdetail.vue?vue&type=style&index=0&id=bdc7357c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports